import { cipo } from 'cipo';
import moment from 'moment-timezone';
import { LegacyIcons } from 'src/app/legacy/constants';
import { FormattingType, FormattingValueType, RestrictionType } from 'src/app/models/module/fields/enums';
import { DATE_TIME_FORMATS } from 'src/app/shared/consts';
import { environment } from 'src/environments/environment';

const EMPTY = '-';

cipo.factory('userService', ['$http', '$q', 'localStorageService', 'URI', 'jsToNg', 'userServiceNg1', '$timeout', 'CIPO_ADMIN_ROLE_ID',
    function ($http, $q, localStorageService, URI, jsToNg, userServiceNg1, $timeout, CIPO_ADMIN_ROLE_ID)
    {
        var userService = {};
        userService.redirectPage = null;

        userService.init = function () {
            userService.tenantId = null;
            userService.hasTenantsLoaded = false;
            userService.isCurrentContractPeriodsChanged = false;
            userService.hasModulesLoaded = false;
            userService.isUserLoaded = false;
            userService.isAppBooted = false;
            userService.isReloadGrid = false;
            userService.isReloadModuleInformation = false;
            userService.targetState = null;
            userService.firstPage = 'personal-dashboard';
            userService.system = {
                userdata: {
                    contractId: 0,
                    // True if user has any roles for correspondence with read permission
                    hasCorrespondenceAccess: false
                },
                context: {
                    program: undefined,
                    project: undefined,
                    contract: undefined,
                },
                contextTree: {
                    currencies: [],
                    modules: [],
                    programs: [],
                    loaded: false,
                },
                contextUseOnlyContract: true,
                impList: [],
                tenants: [],
                tenantsLookup: {},
                contracts: [],
                menu: [],
                modules: {},
                modulesList: [],
                permissions: {},
                mNames: {},
                icons: [],
                mimeTypes: {dict: {}, list: []},
                selectedModuleId: null,
            };
        };

        userService.init();

        // clear
        userService.clearData = function ()
        {
            userService.init();
        };

        userService.mimeTypes = function ()
        {
            var p = $q.defer();
            var mimetypes = { dict: {}, list: [] };
            $http[URI.FIELD_DEFINITION.MIME_TYPES_DICT.method](URI.FIELD_DEFINITION.MIME_TYPES_DICT.toString())
                .then(function (r)
                {
                    if (r && r.data.length)
                    {
                        for (var i = 0; i < r.data.length; i++)
                        {
                            mimetypes.list.push(r.data[i]);
                            mimetypes.dict[r.data[i].key] = r.data[i];
                        }
                    }
                    userService.system.mimeTypes = mimetypes;
                    p.resolve();
                })
                .catch(function (e)
                {
                    console.error(e);
                    p.reject(e);
                    // Message.dberror(e);
                });

            return p.promise;
        };

        userService.setUser = function (user) {
            if (window.StonlyWidget) {
                window.StonlyWidget('identify', user.id.toString());
            }
            for (var key in user) {
                if (key !== 'context') {
                    userService.system.userdata[key] = user[key];
                }
            }
            userService.system.icons = new LegacyIcons();
            if (userService.system.userdata.ianaTimeZoneId) {
                moment.tz.setDefault(userService.system.userdata.ianaTimeZoneId);
            }
            userService.isUserLoaded = true;
        }

        // Mirrors the backend IsSignaturePayloadValid: Draw/Text (type 1/2) require signatureText; Image (type 3) requires signature binary.
        userService.userHasSignature = function () {
            var sig = userService.system.userdata.signature;
            if (!sig) { return false; }
            var type = sig.type;
            if (type === 1 || type === 2) { return !!sig.signatureText; }
            if (type === 3) { return !!sig.signature; }
            return false;
        };

        userService.setLastVisitedModule = function (moduleId) {
            var p = $q.defer();
            if (moduleId === null || moduleId === undefined) {
                // skip if no module id is passed
                p.resolve();
                return p.promise;
            }
            $http.post(environment.baseApiUrl + '_api/User/SetLastVisitedModule', {}, { params: { moduleId } })
            .then(function () {
                p.resolve();
            })
            .catch(function (e) { p.reject(); });
            return p.promise;
        }

        userService.setTenants = function (tenants) {
            userService.system.tenants = [...tenants];
            if (tenants && tenants.length) {
                for (var i = 0; i < tenants.length; i++) {
                    userService.system.tenantsLookup[tenants[i].id] = {...tenants[i]};
                }
            }
            userService.hasTenantsLoaded = (tenants || []).length > 0; 
        };

        userService.setActiveTenant = function (tenantId) {
            userService.tenantId = tenantId;
        };

        userService.closeContract = function (statusType, entityInstanceId) {
            // 1 - close
            // 2 - reopen
            // 3 - archive
            // redo context only if we are changing current contract
            if (entityInstanceId == userService.system.context.contract?.entityInstanceId) {
                // update the current context
                userService.setContext({
                    ...userService.system.context,
                    contract: {
                        ...userService.system.context.contract,
                        isArchived: statusType == 3,
                        isClosed: statusType == 1
                    }
                });
            }
            else {
                // force refresh of the context on Angular to update the changed contract
                userService.triggerRefreshInAngular({context: true});
            }
        }

        userService.setModules = function (modules) {
            userService.system.menu = [...modules];
            userService.system.modules = userService.parseModulesList([...modules]);
            userService.parseModuleNames();
            userService.isLoadingMenu = false; 
            userService.hasModulesLoaded = (modules || []).length > 0; 
        }

        userService.waitForAngularToLoadDependenciesResponse = function () {
            return $q(function(resolve) {
                function checkCondition() {
                    if (userService.isUserLoaded && userService.hasTenantsLoaded && userService.hasModulesLoaded) {
                        resolve();
                    } else {
                        $timeout(checkCondition, 100);
                    }
                }
                checkCondition();
            });
        }

        userService.parseModuleNames = function ()
        {
            var names = {};

            for (var key in userService.system.modules)
            {
                if (userService.system.modules.hasOwnProperty(key))
                {
                    names[key] = userService.system.modules[key].name;
                }
            }

            userService.system.mNames = names;
        };

        userService.bfs = function (tree, childrenKey, idKey, result)
        {
            if (!tree[childrenKey] || tree[childrenKey].length === 0)
            {
                return;
            }

            for (var i = 0; i < tree[childrenKey].length; i++)
            {
                var child = { roles: [], ...tree[childrenKey][i]};

                    if (child['typeId'] === 2 || child['typeId'] === 3)
                    {
                        result[child[idKey]] = child;
                        userService.system.modulesList.push(child);
                    }

                userService.bfs(child, childrenKey, idKey, result);
            }

            return;
        };

        userService.parseModulesList = function (modules)
        {
            var modulesList = {},
                modules = modules || [],
                dataTree = { 'children': modules };
            userService.bfs(dataTree, 'children', 'code', modulesList);
            
            return modulesList;
        };

        userService.getOperationsFor = function (code)
        {
            code = code || '_no_code';
            var operations = {};

            if (userService.system.modules[code])
            {
                if (userService.system.modules[code].operations)
                {
                    for (var i = 0; i < userService.system.modules[code].operations.length; i++)
                    {
                        operations[userService.system.modules[code].operations[i].name] = true;
                    }
                }
            }

            return operations;
        };

        userService.getOperationsForModule = function (moduleId)
        {
            var operations = {};

            var module = userService.system.modulesList.find(m => m.moduleId == moduleId);
            if (module) {
                return userService.getOperationsFor(module.code);
            }

            return operations;
        };

        userService.getWorkflowId = function (moduleId) {            
            return userService.system.modules[userService.getModuleIdentifierById(moduleId)]?.workflowId ?? 0;
        }

        userService.getModuleIdentifierById = function (moduleId) {
            moduleId = moduleId || 0;
            var retval = null;

            for (var key in userService.system.modules) {
                if (userService.system.modules[key]['moduleId'] == moduleId) {
                    retval = userService.system.modules[key]['code'];
                    break;
                }
            }

            return retval;
        };

        userService.getModuleObjectById = function (moduleId) {
            moduleId = moduleId || 0;
            var retval = null;

            for (var key in userService.system.modules) {
                if (userService.system.modules[key]['moduleId'] == moduleId) {
                    retval = userService.system.modules[key];
                }
            }

            return retval;
        };

        userService.getPermissions = function (code)
        {
            code = code || 'no_code';

            var permissions = {};

            if (userService.system.modules[code])
            {
                for (var i = 0; i <= userService.system.modules[code]?.operations?.length; i++)
                {
                    if (userService.system.modules[code].operations[i]?.name)
                        permissions[userService.system.modules[code].operations[i].name] = true;
                }
            }

            return permissions;
        };

        userService.getPermissionsIdList = function (code) {
            code = code || 'no_code';
            if (userService.system.modules[code])
            {
                var permissions = (userService.system.modules[code].operations || []).map(o => o.id);
                return permissions;
            }
            return [];
        };

        userService.currentTenant = function () {
            var sTenant = localStorageService.get('CurrentTenant');
            return userService.tenantId !== null
                ? userService.tenantId 
                : typeof sTenant !== 'undefined'
                    ? sTenant : null;
        };

        userService.getTenantIdentifierById = function (tenantId)
        {
            tenantId = tenantId || -1;
            if (tenantId > 0)
            {
                var selectedTenant = userService.system.tenants
                    .filter(function (o)
                    {
                        return o.id === tenantId;
                    });
                return selectedTenant[0] ? selectedTenant[0].name.toString().toLowerCase() : null;
            } 
            
            return undefined;
        };

        userService.setContract = function (contractId) {
            userService.setContext({...{
                contract: { 
                    id: contractId * 1
                },
            }});
        };

        userService.setContext = function (context, addLastUsedContract) {
            var p = $q.defer();

            if (!context) {
                userService.system.context = undefined;
                p.resolve();
                return p.promise;
            }

            var contractChanged = (context.contract?.id ?? 0) !== (userService.system.userdata.contractId ?? 0);
            var lastContextEntityInstanceId = userService.system.lastContext?.contract?.entityInstanceId ?? userService.system.lastContext?.project?.entityInstanceId ?? userService.system.lastContext?.program?.entityInstanceId;
            var contextEntityInstanceId = userService.system.context?.contract?.entityInstanceId ?? userService.system.context?.project?.entityInstanceId ?? userService.system.context?.program?.entityInstanceId;
            var thisContextEntityInstanceId = context?.contract?.entityInstanceId ?? context?.project?.entityInstanceId ?? context?.program?.entityInstanceId;
            var contextChanged = contextEntityInstanceId !== lastContextEntityInstanceId || contextEntityInstanceId !== thisContextEntityInstanceId;

            if (contractChanged || contextChanged) {
                userService.system.context = {...context};
                jsToNg.setContext(userService.system.context);
            }
            else {
                addLastUsedContract = false;
            }
            
            if (contextChanged) {
                userService.system.userdata.contractEntityInstanceId = undefined;
                userService.system.lastContext = {...context};
                addLastUsedContract = true;
            }
            else if (contractChanged && context.contract) {
                userService.system.userdata.contractId = context.contract.id;
                userService.system.userdata.contractEntityInstanceId = context.contract.entityInstanceId;
                userService.system.lastContext = {...context};
            }
        
            if (addLastUsedContract !== false) {
                $http.post(environment.baseApiUrl + '_api/Contracts/AddLastUsedContext', context)
                    .then(function () {
                        p.resolve();
                    })
                    .catch(function (e) { console.error(e); p.reject(); });
            }
            else {
                p.resolve();
            }

            return p.promise;
        };

        userService.changeContextBehavior = function (moduleAbbr) {
            // only Project Files will have a context selection
            // other modules will have a contract selection
            if (moduleAbbr !== 'FCM') {
                userService.system.contextUseOnlyContract = true;
                if (userService.system.lastContext) {
                    userService.setContext(userService.system.lastContext, false);
                }
                else {
                    userService.ensureContractIsSelected();
                }
            }
            else {
                userService.system.contextUseOnlyContract = false;
                userService.setContext({...userService.system.context}, false);
                userService.ensureContractIsSelected();
            }
        }

        userService.ensureContractIsSelected = function () {
            if (!userService.system.userdata.id) {
                // skip if the user is not loaded
                return;
            }

            var contextEntityInstanceId = userService.system.context?.contract?.entityInstanceId ?? userService.system.context?.project?.entityInstanceId ?? userService.system.context?.program?.entityInstanceId;

            if (contextEntityInstanceId) {
                userService.setContext({...userService.system.context}, false);
            }
        }

        userService.setContextTree = function (contextTree) {
            userService.system.contextTree = contextTree || {};
            userService.system.contextTree.loaded = true;
            userService.system.context = userService.getContextWhenContractIsIncomplete();
            userService.ensureContractIsSelected();
        }

        userService.getContextProjects = function () {
            if (!userService.system.contextTree || !userService.system.contextTree.loaded) {
                return [];
            }
            var projects = (userService.system.contextTree.programs || []).reduce((acc, program) => {
                acc.push(...(program.projects || []));
                return acc;
              }, []);
            return projects || [];
        }

        userService.getContextProject = function (projectId, entityInstanceId, projectNo) {
            var project = userService.getContextProjects().find(p => 
                (p.id * 1) === (projectId * 1) 
                || (p.entityInstanceId * 1) === (entityInstanceId * 1) 
                || p.no === projectNo);
            return project;
        }

        userService.getContextProgram = function (programId, entityInstanceId, programNo) {
            var program = userService.getContextProjects().find(p => 
                (p.id * 1) === (programId * 1) 
                || (p.entityInstanceId * 1) === (entityInstanceId * 1) 
                || p.no === programNo);
            return program;
        }

        userService.getContextContracts = function () {
            var contracts = userService.getContextProjects().reduce((acc, project) => {
                acc.push(...(project.contracts || []));
                return acc;
              }, []);
            return contracts || [];
        }

        userService.getContextContract = function (contractId, entityInstanceId, contractNo) {
            var contract = userService.getContextContracts().find(c => 
                (c.id * 1) === (contractId * 1) 
                || (c.entityInstanceId * 1) === (entityInstanceId * 1) 
                || c.no === contractNo);
            return contract;
        }

        userService.getProjectForContract = function (contractId, entityInstanceId, contractNo) {
            var project = userService.getContextProjects().find(p => p.contracts.some(c => 
                (c.id * 1) === (contractId * 1) 
                || (c.entityInstanceId * 1) === (entityInstanceId * 1) 
                || c.no === contractNo));
            return project;
        }

        userService.getProgramForContract = function (contractId, entityInstanceId, contractNo) {
            var project = userService.getProjectForContract(contractId, entityInstanceId, contractNo);
            var program = (userService.system.contextTree.programs || []).find(p => (p.projects || []).some(j => 
                (j.id * 1) === (project?.id * 1) 
                || (j.entityInstanceId * 1) === (project?.entityInstanceId * 1) 
                || j.no === project?.no));
            return program;
        }

        userService.getContextWhenContractIsIncomplete = function () {
            var ctx = {...userService.system.context};
            var contract = ctx?.contract;
            if (!contract?.id || !contract?.entityInstanceId) {
                ctx.contract = userService.getContextContract(contract?.id, contract?.entityInstanceId);
            }
            if (!ctx.project) {
                ctx.project = userService.getProjectForContract(contract?.id, contract?.entityInstanceId);
            }
            if (!ctx.program) {
                ctx.program = userService.getProgramForContract(contract?.id, contract?.entityInstanceId);
            }
            return ctx;
        }

        userService.isContractClosed = function (contractId, entityInstanceId, contractNo) {
            var contract = userService.getContextContract(contractId, entityInstanceId, contractNo);
            return contract && (contract.isArchived === true || contract.isClosed === true);
        }

        userService.addZ = function (date) {
            var ret = date || null;
            if (date && date.indexOf && date.indexOf("Z") == -1)
                ret = date + "Z";
            return ret;
        }

        userService.momentDate = function (date) {
            if (!date || date === EMPTY) {
                return null;
            }
            var dt;
            if (typeof date === 'string') {
                dt = moment.utc(userService.addZ(date)).utcOffset(0);
            }
            else if (date instanceof Date) {
                dt = moment(date);
            }
            else {
                dt = date;
            }
            return dt;
        }
        
        userService.momentDateTime = function (date, restrictions) {
            if (!date || date === EMPTY) {
                return null;
            }
            var isDate = (restrictions || []).some(r => r.key == 5 && r.value == 3);
            if (restrictions && isDate) {
                return userService.momentDate(date);
            }
            return moment.utc(userService.addZ(date)).tz(userService.system.userdata.ianaTimeZoneId);
        }
      
        userService.userSettings = function () {
            return userServiceNg1.getUserSettings() ?? {
                dateFormat: 'MM/DD/YYYY',
                datetimeFormat: 'MM/DD/YYYY hh:mm A',
                timeFormat: 'hh:mm A',
                decimalSeparator: '.',
                thousandSeparator: ',',
            };
        }

        userService.formatDate = function (date) {
            return userService.momentDate(date)?.format(userService.userSettings().dateFormat) ?? EMPTY;
        }

        userService.formatTime = function (time) {
            return userService.momentDateTime('1970-01-02T' + time)?.format(userService.userSettings().timeFormat) ?? EMPTY;
        }

        userService.formatTimeFromDateTime = function (date) {
            return userService.momentDateTime(date)?.format(userService.userSettings().timeFormat) ?? EMPTY;
        }

        userService.formatDateTime = function (date) {
            return userService.momentDateTime(date)?.format(userService.userSettings().datetimeFormat) ?? EMPTY;
        }

        userService.formatDateTimeCustom = function (date, format) {
            var hasTime = (format || '').toLowerCase().includes('hh:mm');
            var dt = hasTime ? userService.momentDateTime(date) : userService.momentDate(date);
            return dt?.format(format) ?? EMPTY;
        }

        userService.formatDateTimeBasedOnRestrictionsLookup = function (date, restrictionsLookup) {
            if (restrictionsLookup[5] == 5) {
                return userService.formatTimeFromDateTime(date);
            } else if (restrictionsLookup[5] == 3) {
                return userService.formatDate(date);
            }
            return userService.formatDateTime(date);
        }

        userService.formatDateTimeBasedOnRestrictions = function (date, restrictions) {
            // defaults to date format if no restrictions are passed in
            var isDate = (restrictions || []).some(r => r.key == 5 && r.value == 3);
            var isTime = (restrictions || []).some(r => r.key == 5 && r.value == 5);
            if (isTime) {
                return userService.formatTimeFromDateTime(date);
            } else if (isDate) {
                return userService.formatDate(date);
            }
            return userService.formatDateTime(date);
        }

        userService.getDateTimeFormatBasedOnRestrictions = function (restrictions) {
            // defaults to date format if no restrictions are passed in
            var isDate = (restrictions || []).some(r => r.key == 5 && r.value == 3);
            var isTime = (restrictions || []).some(r => r.key == 5 && r.value == 5);
            return isDate ? userService.userSettings().dateFormat : isTime ? userService.userSettings().timeFormat : userService.userSettings().datetimeFormat;
        }

        userService.formatDateToIsoBasedOnRestrictionsLookup = function (date, restrictionsLookup) {
            // set format based on restriction
            var isDate = restrictionsLookup[5] == 3;
            return isDate ? userService.momentDate(date)?.format(DATE_TIME_FORMATS.dateIso) : userService.momentDate(date)?.toISOString();
        }

        userService.formatDateToIsoBasedOnRestrictions = function (date, restrictions) {
            // defaults to date format if no restrictions are passed in
            var isDate = (restrictions || []).length === 0 || (restrictions || []).some(r => r.key == 5 && r.value == 3);
            // set format based on restriction
            return isDate ? userService.momentDate(date)?.format(DATE_TIME_FORMATS.dateIso) : userService.momentDate(date)?.toISOString();
        }

        userService.formatDateToIsoBasedOnPickerType = function (date, pickerType) {
            if (!pickerType) {
                return date;
            }
            if (!date) {
                return null;
            }
            if (pickerType == "datepicker") {
                return userService.momentDate(date)?.format(DATE_TIME_FORMATS.dateIso);
            } else if (pickerType == "datetimepiker" || pickerType == "timepicker") {
                return userService.momentDateTime(date)?.toISOString();
            }
            return null;
        }

        userService.daysDiff = function (date, dateToSubstract) {
            if (dateToSubstract) {
                return userService.momentDate(date).diff(userService.momentDate(dateToSubstract), 'days');
            }
            return userService.momentDate(date).diff(moment(), 'days');
        }

        userService.formatNumber = function (value, decimals, showComma, showCurrency, showPercentage, currency, percentageSymbol) {
            if (value === undefined || value === null) {
                return '';
            }

            decimals = decimals ?? 0;
            showComma = showComma ?? true;
            showCurrency = showCurrency ?? false;
            showPercentage = showPercentage ?? false;
            percentageSymbol = percentageSymbol ?? '%';

            const currencySymbolDefault = '$';
            const leftSideDefault = true;
            const noSpaceDefault = true;
            const userSettings = userService.userSettings();
            const decimalSeparator = userSettings.decimalSeparator ?? '.';
            const thousandSeparator = userSettings.thousandSeparator ?? ',';
          
            let newValue = value;
            if (showCurrency && value?.toString().includes(currency?.symbol ?? currencySymbolDefault)) {
                return value.toString();
            } else if (showPercentage && value?.toString().includes(percentageSymbol)) {
                return value.toString();
            }
        
            const numberValue = typeof newValue == 'string' ? Number(newValue?.toString()) : newValue;
            if (numberValue === undefined || numberValue === null || isNaN(numberValue)) {
                return value?.toString();
            }
        
            const numberValueAbs = Math.abs(numberValue);
        
            if (showCurrency && (currency === null || currency === undefined)) {
                currency = { symbol: currencySymbolDefault };
            }
        
            const numberLocale = userService.getNumberLocale(decimalSeparator, thousandSeparator);
            const options = {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
                useGrouping: showComma,
            };
            const ret = new Intl.NumberFormat(numberLocale, options).format(numberValueAbs);
        
            const prefixNegative = numberValue < 0 ? EMPTY : '';
        
            if (showPercentage) {
                return `${prefixNegative}${ret}${percentageSymbol}`;
            }
        
            if (showCurrency) {
                const leftSide = currency.leftSide ?? leftSideDefault;
                const noSpace = currency.noSpace ?? noSpaceDefault;
            
                const prefixSpace = !noSpace && leftSide ? ' ' : '';
                const suffixSpace = !noSpace && !leftSide ? ' ' : '';
                const prefixCurrency = leftSide ? currency.symbol : '';
                const suffixCurrency = !leftSide ? currency.symbol : '';
            
                if (noSpace) {
                    return `${prefixNegative}${prefixCurrency}${ret}${suffixCurrency}`;
                }
            
                return `${prefixCurrency}${prefixSpace}${prefixNegative}${ret}${suffixSpace}${suffixCurrency}`;
            }
        
            return `${prefixNegative}${ret}`;
        }

        userService.getNumberLocale = function (decimalSeparator, thousandSeparator) {
            if (decimalSeparator === ',' && thousandSeparator === '.') {
                return 'ro-RO';
            }
            return 'en-US';
        }

        userService.formatNumberWithFormattings = function (value, formattings, restrictions, currency, percentageSymbol, hasMultipleValues) {
            const numberFormatting = (formattings || []).find(f => f.key == FormattingType.Number);
            const decimalFormatting = (formattings || []).find(f => f.key == FormattingType.Decimals);
            const showComma = !!(restrictions || []).find(f => f.key == RestrictionType.ShowThousandSeparator);
            const showCurrency = numberFormatting && numberFormatting.value == FormattingValueType.Money;
            const showPercentage = numberFormatting && numberFormatting.value == FormattingValueType.Percentage;

            let decimals = decimalFormatting ? decimalFormatting.formattingValue : 0;

            if (!hasMultipleValues) {
                return userService.formatNumber(
                    value,
                    decimals,
                    showComma,
                    showCurrency,
                    showPercentage,
                    currency,
                    percentageSymbol
                );
            }
            else {
                return ((value || '').split(', ') || []).map(v => (
                    userService.formatNumber(
                        v,
                        decimals,
                        showComma,
                        showCurrency,
                        showPercentage,
                        currency,
                        percentageSymbol
                    )
                )).join(', ');
            }
        }

        userService.formatCurrency = function (value, currency, decimals, showComma) {
            const showCurrency = currency !== null && currency !== undefined;
            return userService.formatNumber(
                value,
                decimals,
                showComma,
                showCurrency,
                false,
                currency
            );
        }

        userService.revertLocaleNumber = function (value) {
            const userSettings = userService.userSettings();
            const decimalSeparator = userSettings.decimalSeparator ?? '.';
            const thousandSeparator = userSettings.thousandSeparator ?? ',';
            const baseValue = value?.toString().replaceAll(thousandSeparator, '').replace(decimalSeparator, '.');
            const newValue = parseFloat(baseValue);
            return isNaN(newValue) ?  undefined : newValue;
        }

        // triggers
        // refreshData: RefreshFromJs (check js-to-ng.service.ts)
        userService.triggerRefreshInAngular = function (refreshData) {
            refreshData?.context === true && (userService.system.contextTree.loaded = false);
            refreshData?.tenants === true && (userService.hasTenantsLoaded = false);
            refreshData?.user === true && (userService.isUserLoaded = false);
            refreshData?.menu === true && userService.resetLoadingMenuFlags();
            jsToNg.triggerRefresh(refreshData);
        }

        userService.resetLoadingMenuFlags = function () {
            // these flags will be set when data is coming back from angular to js, see userService.setModules
            userService.hasModulesLoaded = false;
            userService.isLoadingMenu = true;
        };

        userService.triggerUserRefresh = function () {
            userService.triggerRefreshInAngular({user: true});
        };

        userService.triggerMenuRefresh = function () {
            userService.triggerRefreshInAngular({menu: true});
        };

        userService.triggerEmailCountRefresh = function () {
            userService.triggerRefreshInAngular({emailCount: true});
        };

        userService.userHasCipoAdmin = function () {
            return userService.system.userdata.roles?.some(u => u.key == CIPO_ADMIN_ROLE_ID);
        }

        userService.userHasAnyElevatedRole = function () {
            return userService.system.userdata.roles?.some(u => u.elevated);
        }

        userService.getContractIdFromQueryUrl = function () {
            // it searched the contractId in the query url: i.e. tenant-abbr/emails?e=10120&f=-1&contractId=52
            var searchParams = new URLSearchParams(window.location.search);
            var contractIdKey = [...searchParams.keys()].find(key => key.toLowerCase() === 'contractid');
            var contractId = contractIdKey ? searchParams.get(contractIdKey) : undefined;
            return contractId && !Number.isNaN(contractId) ? Number(contractId) : undefined;
        }

        userService.setContextModuleNames = function (ctx) {
            ctx.contractModuleName = userService.getContractModuleName();
            ctx.projectModuleName = userService.getProjectModuleName();
            ctx.programModuleName = userService.getProgramModuleName();
        }

        userService.getContractModuleName = function () {
            return userService.system.modules['CT']?.name || 'Contract';
        }

        userService.getProjectModuleName = function () {
            return userService.system.modules['P']?.name || 'Project';
        }

        userService.getProgramModuleName = function () {
            return userService.system.modules['PRG']?.name || 'Program';
        }

        return userService;
    }]);
